import React from 'react';
import { getAspectRatio } from '@marvelapp/core';
import { AspectRatio } from '@marvelapp/ui';
import { ImageDownloadError, ImageUploadFailedError, ImageUploadPendingError, } from './ImageError';
export default function Error(_a) {
    var frame = _a.frame, status = _a.status, orientation = _a.orientation;
    var ratio = getAspectRatio(frame, orientation);
    return (React.createElement(AspectRatio, { ratio: ratio },
        React.createElement(ErrorComponent, { status: status })));
}
function ErrorComponent(_a) {
    var status = _a.status;
    if (status.uploadError) {
        return React.createElement(ImageUploadFailedError, null);
    }
    if (status.uploadPending) {
        return React.createElement(ImageUploadPendingError, null);
    }
    if (status.downloadError) {
        return React.createElement(ImageDownloadError, null);
    }
}
